import {CommonModule, DecimalPipe} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {UIRouterModule} from '@uirouter/angular';
import {PipesModule} from '../pipes/pipes.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import {LoaderComponent} from './global/loader/loader.component';

// Components================================
import {CheckBoxComponent} from './global/checkbox/checkbox.component';
import { GlobalHeaderComponent } from './global/header/header.component';
import {GlobalNavigationComponent} from './global/navigation/navigation.component';
import {EventsCalendarComponent} from './global/events-calendar/events-calendar.component';
import {DatepickerComponent} from './global/datepicker/datepicker.component';
import {TravelsListComponent} from './travels-list/travels-list.component';
import {ClientDetailsComponent} from './client/details/client-details.component';
import {ClientTravelHistoryComponent} from './client/client-travel-history/client-travel-history.component';
import {PopupComponent} from './popups/popup/popup.component';
import {MemberComponent} from './popups/member/member.component';
import {EditPasswordComponent} from './popups/edit-password/edit-password.component';
import {RequestServiceComponent} from  './popups/request-service/request-service.component';
import {ConfirmPopupComponent} from './popups/confirm/confirm.component';

@NgModule({
  exports: [
    CheckBoxComponent,
    GlobalHeaderComponent,
    GlobalNavigationComponent,
    EventsCalendarComponent,
    TravelsListComponent,
    ClientDetailsComponent,
    ClientTravelHistoryComponent,
    PopupComponent,
    MemberComponent,
    DatepickerComponent,
    EditPasswordComponent,
    RequestServiceComponent,
    ConfirmPopupComponent,
    CKEditorModule,
    LoaderComponent
  ],
  declarations: [
    CheckBoxComponent,
    GlobalHeaderComponent,
    GlobalNavigationComponent,
    EventsCalendarComponent,
    TravelsListComponent,
    ClientDetailsComponent,
    ClientTravelHistoryComponent,
    PopupComponent,
    MemberComponent,
    DatepickerComponent,
    EditPasswordComponent,
    RequestServiceComponent,
    ConfirmPopupComponent,
    LoaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    UIRouterModule,
    PipesModule,
    CarouselModule,
    CKEditorModule,
  ],
  providers: [
    DecimalPipe
  ]
})
export class ComponentsModule {
}
